/**
 * @todo Add polyfill for command attributes
 */

document.addEventListener("DOMContentLoaded", navigationInit);

function navigationInit() {
  const modals = /** @type NodeListOf<HTMLDialogElement> */ (
    document.querySelectorAll("dialog,[popover]")
  );

  modals.forEach((modal) => {
    const links = modal.querySelectorAll("a[href]");
    links.forEach((link) => {
      link.addEventListener("click", () => {
        modal.requestClose();
      });
    });
  });
}
